module.exports = __webpack_public_path__ + "media/cruise.457a4001.jpg";